export default {
  hadith: [],

  allNews: [],

  lastNews: [],

  chooseNews: [],

  electronicServices: [],

  newsLetters: [],

  moreLikeNews: [],

  groups: [],

  newsGroups: [],

  moreViewNews: [],

  newestNews: [],

  oneNews: {},

  contactUs: [],

  introductions: [],
  oneIntroduction: {},

  lastProvinceNews: [],

  links: [],

  slider: [],

  banner: [],

  zones: [],

  lastSubjects: [],
  chooseSubjects: [],
  moreLikeSubjects: [],
  moreviewSubjects: [],
  newestSubjects: [],
  allSubjects: [],
  getOneSubjects: {},
};
